<template>
  <div class="local-allocation-orders">
    <div class="table-header mt-15">
      <h3>ORDER ALLOCATIONS IN PROGRESS:</h3>
    </div>
    <vue-good-table
        :columns="columns"
        :rows="rows"
        :sort-options="{
           enabled: false
        }"
    >
      <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'info'" class="info-con">
              <span v-for="(item,index) in props.row.info" :key="index" class="info-item sk-info-item" :class="borderClass(index,props.row.info.length)">
                <span class="sk-info-item-title">{{ item.title }}</span>
                <span class="sk-info-item-qty">{{ item.qty }}</span>
              </span>

          </span>
        <span v-else-if="props.column.field === 'po'">
              <span v-if="props.row.po.po_required&&props.row.po.po_number">{{ props.row.po.po_number }}</span>
              <span v-else-if="props.row.po.po_required&&!props.row.po.po_number">...</span>
              <span v-else>not required</span>
          </span>
        <span v-else-if="props.column.field === 'update'">
              <button class="order-btn orange" v-on:click.prevent="()=>onUpdateItem(props.row.id)">Update</button>
          </span>
        <span v-else-if="props.column.field === 'delete'">
              <button class="order-btn red" v-on:click.prevent="()=>onDeleteItem(props.row.id)">Delete</button>
          </span>
        <span v-else>
      {{ props.formattedRow[props.column.field] }}
    </span>
      </template>
    </vue-good-table>
    <div class="error-con" v-if="errorArray.length>0">
      <div v-for="(item,index) in errorArray" :key="'error'+index" class="error-item">{{item}}</div>
    </div>
    <div class="button-con">
      <CButton color="green" text="Finish Allocating" @click="onFinishAllocated"/>
    </div>
  </div>
</template>

<script>
import {VueGoodTable} from 'vue-good-table';
import CButton from "../common/CButton.vue";

export default {
  name: 'LocalAllocationOrders',
  components: {
    VueGoodTable,
    CButton
  },
  props: {
    errorArray: Array,
    localOrdersData: Array,
    lineItems: Array,
    onFinishAllocated: Function,
    onDeleteItem: Function,
    onUpdateItem: Function
  },
  data() {
    return {
      columns: [
        {
          label: 'Address',
          field: 'address',
          type: 'string',
          width: '25%'
        },
        {
          label: 'PO',
          field: 'po',
          type: 'string',
          width: '10%'
        },
        {
          label: 'Items Allocation Info',
          field: 'info',
          type: 'string',
          width: '45%',
          tdClass: 'sk-no-padding',
        },
        {
          label: 'Update',
          field: 'update',
          width: '10%'
        },
        {
          label: 'Delete',
          field: 'delete',
          width: '10%'
        },

      ],
    }
  },
  computed: {
    rows() {
      return this.localOrdersData.map((item,index) => {
        let data = {
          id: index,
          address: item.address_name,
          po: {
            po_required: item.po_required,
            po_number: item.po_number,
            poDate: item.poDate
          }
        }
        let allocationItems = [];
        for (let prop in item.allocation_qty) {
          allocationItems.push({
            title: this.itemName(prop),
            qty: item.allocation_qty[prop]
          })
        }
        data.info = allocationItems;
        return data;
      });
    },
  },
  mounted() {

  },
  methods: {
    itemName(id) {
      let item = this.lineItems.find(item => {
        return item.id === Number(id)
      });
      return item.title;
    },
    onFinishAllocatedClick: function (){
      // console.log(this);
      // console.log(this.props);
      // console.log(this.onFinishAllocated);
      this.onFinishAllocated();
    },
    borderClass(index, infoLength){
      return index!==infoLength-1?'sk-border-bottom':''
    }
  }
}
</script>